import React, { useState } from "react";
import moment from "moment";
import { Image, Button } from "react-bootstrap";
import { PopupIconButtonReusable } from "../allPopupReusableIconButton/PopupIconButtonReusable";
import DeletePopup from "../smallPopup/DeletePopup";
import EditWaitTime from "../tableNumberPopup/EditWaitTime";
import { NewCountDown } from "../tableNumberPopup/NewCountDown";
import LocationReusable from "../locationReusablePopup/LocationReusable";
import CallingButtonPopup from "../CallingButtonPopup";
import { SendSmsButton } from "../SendSmsButton";
import { NotificationButton } from "../NotificationButton";
// import EnterTableNumber from "../tableNumberPopup/EnterTableNumber";

export const EditDetailsTop = ({ allPropsData, allPropsDataTwo }) => {
  /*******************************
   * @DESC Pending Total Wait time
   *******************************/
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(allPropsData.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  /*******************************
   * @DESC Seating Total Wait time
   *******************************/
  const seatedTime = new Date(allPropsData.seatedTime);
  const updatedAt = new Date(allPropsData.updatedAt);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  var updatedTimeNew = moment(updatedAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);
  let dataThreeSeated = new Date(updatedTimeNew);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let totalUpdatedTime = dataThreeSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);
  let minutesUpdatedTime = Math.floor(totalUpdatedTime / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " HH : " + nMinutesSeated + " min";
  }

  function upated_time_difference(minutesUpdatedTime) {
    var hours = Math.floor(minutesUpdatedTime / 60);
    var nMinutesUpdatedTime = minutesUpdatedTime % 60;
    return hours + " HH : " + nMinutesUpdatedTime + " min";
  }
  // timer edit
  let updatedTime = new Date(allPropsData.wait_time_date);
  let currentTimeTwo = new Date().getTime();
  let updatedTimeNew1 = updatedTime.getTime();
  let waitTime = allPropsData.wait_time * 60 * 1000;
  let updateWaitTime = updatedTimeNew1 + waitTime;
  let diff = updateWaitTime - currentTimeTwo;
  const [textShow, setTextShow] = useState(false);
  const textToggle = () => {
    setTextShow({
      textShow: !textShow.textShow,
    });
  };
  return (
    <React.Fragment>
      <div
        className={`border-bottom border-top px-3 ${
          allPropsData.service_type === "RESERVATION"
            ? "enLeftYellowLine"
            : "enLeftGReenLine"
        }`}
      >
        <div className="row justify-content-between">
          <div className="col-5 py-3">
            <div className="d-flex align-items-center">
              {allPropsData.isWalkIn === true &&
              allPropsData.service_type === "SEATING" ? (
                <Image
                  src={require("../../../../assets/images/ActionImages/image/walkin.svg")}
                  alt="Order Type"
                  title="Order Type"
                  className="order-type-Image mr-2"
                />
              ) : null ||
                (allPropsData.isWalkIn === false &&
                  allPropsData.service_type === "SEATING") ? (
                <Image
                  src={require("../../../../assets/images/ActionImages/image/waitlist.svg")}
                  alt="Order Type"
                  title="Order Type"
                  className="order-type-Image mr-2"
                />
              ) : null || allPropsData.service_type === "RESERVATION" ? (
                <Image
                  src={require("../../../../assets/images/ActionImages/image/reservation.svg")}
                  alt="Order Type"
                  title="Order Type"
                  className="order-type-Image mr-2"
                />
              ) : null}
              <div>
                <div className="f12-500">{allPropsDataTwo.name}</div>
                <div className="f10-500 opacity5">#{allPropsData.diner_id}</div>
              </div>
            </div>
          </div>
          <div className="col-3 py-3 px-0 request-accept-cancelled-center section-two inline-section-two">
            <div className="d-flex">
              <div className="col-auto p-0">
                <div className="f14-700">
                  {allPropsData.adult_count + allPropsData.kids_count}
                </div>
                <div className="f10-700">PAX</div>
              </div>
              <div className="col-auto px-1">
                {allPropsData.adult_count === 0 ? null : (
                  <div className="d-flex align-items-center mb-2">
                    <Image
                      src={require("../../../../assets/images/ActionImages/employees.png")}
                      fluid
                      alt="Adult"
                      title="Adult"
                      className="icon-image"
                    />
                    <span className="">{allPropsData.adult_count}</span>
                  </div>
                )}
                {allPropsData.kids_count === 0 ? null : (
                  <div className="d-flex align-items-center">
                    <Image
                      src={require("../../../../assets/images/ActionImages/children.png")}
                      fluid
                      alt="Children"
                      title="Children"
                      className="icon-image"
                    />
                    <span className="f9-400">{allPropsData.kids_count}</span>
                  </div>
                )}
              </div>
              <div className="col-auto p-0">
                {allPropsData.handicap_chair === 0 ? null : (
                  <div className="d-flex align-items-center mb-2">
                    <Image
                      src={require("../../../../assets/images/ActionImages/highchair.png")}
                      fluid
                      alt="Highchair"
                      title="Highchair"
                      className="icon-image-small"
                    />
                    <span className="f9-400">
                      {allPropsData.handicap_chair}
                    </span>
                  </div>
                )}
                {allPropsData.high_chair === 0 ? null : (
                  <div className="d-flex align-items-center">
                    <Image
                      src={require("../../../../assets/images/ActionImages/wheelchair.png")}
                      fluid
                      alt="Wheel Chair"
                      title="Wheel Chair"
                      className="icon-image-small"
                    />
                    <span className="f9-400">{allPropsData.high_chair}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-4 py-3">
            <div
              className={
                allPropsData.service_type === "reservation" ||
                allPropsData.diner_status === "SEATED" ||
                allPropsData.diner_status === "NOTSEATED" ||
                allPropsData.diner_status === "PENDING" ||
                allPropsData.diner_status === "REJECTED" ||
                allPropsData.diner_status === "COMPLETED"
                  ? "card-header-right justify-content-center"
                  : "card-header-right"
              }
            >
              {allPropsData.diner_status === "PENDING" ? (
                <div>
                  <div>
                    <p className="f14-700 text-red">Pending</p>
                  </div>
                </div>
              ) : null || allPropsData.service_type === "RESERVATION" ? (
                <div>
                  <p className="f12-500 text-dark">25Th Aug</p>
                  <div>
                    <p className="f14-700 text-red">09:04 PM</p>
                  </div>
                </div>
              ) : null || allPropsData.diner_status === "SEATED" ? (
                <div>
                  <div>
                    <p className="f14-700 text-red">00:00</p>
                  </div>
                </div>
              ) : null || allPropsData.diner_status === "NOTSEATED" ? (
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div>
                      <div className="f10-400 opacity5">Timer</div>
                      <p className="f14-700 text-red">
                        <NewCountDown waitNew={diff} />
                      </p>
                    </div>
                  </div>
                  <div className="popup-image">
                    <EditWaitTime allDataProps={allPropsData._id} />
                  </div>
                </div>
              ) : null || allPropsData.diner_status === "REJECTED" ? (
                <div>
                  <p className="f14-700 text-red">Rejected</p>
                </div>
              ) : null || allPropsData.diner_status === "COMPLETED" ? (
                <div>
                  <p className="f14-700 text-red">Completed</p>
                </div>
              ) : null || allPropsData.diner_status === "CANCELLED" ? (
                <div className="w-100">
                  <p className="f14-700 text-red">Cancelled</p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className={`border-bottom enLeftTransparentLine px-3 `}>
        <div className="row justify-content-between">
          <div className="col-4 py-3 border-right">
            <div className="f10-400 opacity5">Seating Preferences</div>
            <div className="f12-500 c_black">
              {allPropsData.seating_preference}
            </div>
          </div>
          <div className="col-5 py-3 px-2 border-right">
            <div className="f10-400 opacity5">Date & Time</div>
            <div className="f12-500 c_black">
              {moment(allPropsData.createdAt).format("Do MMM, YYYY")}{" "}
              {moment(allPropsData.createdAt).format("hh:mm A")}
            </div>
          </div>
          <div className="col-3 py-3 pl-1">
            <LocationReusable dataSend={allPropsData} display={true} />
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-center px-3">
        <div className="d-flex align-items-center justify-content-center py-3">
          <CallingButtonPopup buttonClass="smallButton" />
          <SendSmsButton buttonClass="smallButton" dataSend={allPropsData} />
          <NotificationButton
            buttonClass="smallButton"
            dataSend={allPropsData}
          />
          <Button variant="link" className="enIconBtn mr-3">
            <Image
              src={require("../../../../assets/images/UserManagement/forum.svg")}
              alt="Order Type"
              title="Order Type"
              className="order-type-Image2"
            />
          </Button>
        </div>
        <div className="middle-timer border-left py-3 px-1">
          <p className="f9-400 opacity5 text-center">Total Wait time</p>
          <div className="enTimesLbl d-flex justify-content-center align-items-center">
            <Image
              alt="wait"
              title="wait"
              width="10px"
              height="13px"
              src={require("../../../../assets/images/UserManagement/wait.svg")}
            />
            <p className="f10-500">
              {allPropsData.diner_status === "NOTSEATED"
                ? time_convert(minutes)
                : seated_time_difference(minutesSeated)}
            </p>
          </div>
        </div>
      </div>

      <div className={`border-top enLeftTransparentLine px-3 `}>
        <div className="row justify-content-between">
          <div className="col-4 py-3 border-right">
            <div className="f10-400 opacity5">Table / Room No.</div>
            <div className="f12-500 c_black">
              Room No. - {allPropsData.room_number}
            </div>
            <div className="f12-500 c_black">
              Table No. - {allPropsData.table_number}
            </div>
          </div>
          <div className="col-5 py-3 border-right">
            <div className="f10-400 opacity5">Special Occasion</div>
            <div
              className={`f12-500 c_black ${
                !textShow.textShow ? "enEllips3" : null
              }`}
            >
              {allPropsData.occasion}
            </div>
            <span className="f10-400 cursor text-red" onClick={textToggle}>
              See More
            </span>
          </div>
          <div className="col-3 py-3">
            <div className="f10-400 opacity5">Status</div>
            <p className="f10-500">
              {allPropsData.diner_status === "NOTSEATED" ? (
                <div className="d-flex align-items-center">
                  <span className="mr-2 enYellowDot d-inline-table"></span>
                  <span>{allPropsData.diner_status}</span>
                </div>
              ) : (
                allPropsData.diner_status
              )}
            </p>
          </div>
        </div>
      </div>
      {/* <div className="col-5 col-sm-5 col-md-4 col-lg-3 col-xl-3 section-four">
              <div className="total-time-box">
                <p className="paragraph-text-bold">
                  {allPropsData.diner_status === "PENDING" ||
                  allPropsData.diner_status === "NOTSEATED"
                    ? time_convertPending(minutes)
                    : allPropsData.diner_status === "SEATED" ||
                      allPropsData.diner_status === "COMPLETED"
                    ? seated_time_difference(minutesSeated)
                    : allPropsData.diner_status === "REJECTED" ||
                      allPropsData.diner_status === "CANCELLED"
                    ? upated_time_difference(minutesUpdatedTime)
                    : null}
                </p>
              </div>
            </div> */}
      {/* <div className="col-12 col-sm-12 col-md-11 col-lg-6 col-xl-6 mt-4 section-seven">
        <div className="row">
          <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            {allPropsData.diner_status === "NOTSEATED" ? (
              <div>
                <DeletePopup
                  buttonDisplay="smallCancelButton"
                  displayPopup="resonFforCancellation"
                  buttonText="Cancel"
                  bigText="Are you sure to Cancel ?"
                  dataSend={allPropsData._id}
                />
              </div>
            ) : null || allPropsData.diner_status === "SEATED" ? (
              <div>
                <DeletePopup
                  buttonDisplay="smallCancelButton"
                  displayPopup="seatingUnseated"
                  buttonText="Unseat"
                  bigText="Are you sure to Unseat ?"
                  dataSend={allPropsData}
                />
              </div>
            ) : null || allPropsData.diner_status === "PENDING" ? (
              <div>
                <DeletePopup
                  buttonDisplay="smallCancelButton"
                  displayPopup="resonFforCancellation"
                  buttonText="Reject"
                  bigText="Are you sure to Reject ?"
                  dataSend={allPropsData._id}
                />
              </div>
            ) : null ||
              allPropsData.diner_status === "COMPLETED" ||
              allPropsData.diner_status === "REJECTED" ? (
              <div>
                <DeletePopup
                  buttonDisplay="smallCancelButton"
                  displayPopup="historyReset"
                  buttonText="Reset"
                  bigText="Are you sure to Reset ?"
                  dataSend={allPropsData}
                />
              </div>
            ) : null}
          </div>
          <div className="col-5 col-sm-5 col-md-6 col-lg-6 col-xl-6 text-center seating-preferance-data">
            <p className="paragraph-heading-text">Seating Preferences</p>
            <p className="paragraph-text-bold">
              {allPropsData.seating_preference}
            </p>
          </div>
          <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            {allPropsData.diner_status === "NOTSEATED" ? (
              <div>
                <DeletePopup
                  buttonDisplay="smallSaveButton"
                  displayPopup="SeatedButton"
                  buttonText="Seat"
                  bigText="Are you sure to Seated ?"
                  dataSend={allPropsData._id}
                />
              </div>
            ) : null || allPropsData.diner_status === "SEATED" ? (
              <div>
                <DeletePopup
                  buttonDisplay="smallSaveButton"
                  displayPopup="seatingCompleted"
                  buttonText="Complete"
                  bigText="Are you sure to Completed ?"
                  dataSend={allPropsData}
                />
              </div>
            ) : null || allPropsData.diner_status === "PENDING" ? (
              <DeletePopup
                buttonDisplay="smallSaveButton"
                displayPopup="acceptButton"
                buttonText="Accept"
                bigText="Are you sure you want to accept ?"
                dataSend={allPropsData._id}
              />
            ) : null}
          </div>
        </div>
      </div> */}
    </React.Fragment>
  );
};
